import React from "react";
import Answer from "../Answers/Answer/Answer";
import classes from "./Answers.module.css";
const Answers = ({ question, updateState, goBack }) => {
  const submitAnswer = (answer, answerId, linksTo) => {
    updateState(question.question, answer, answerId, linksTo);
  };
  return (
    <div className={classes.answersButtonContainer}>
      <div className={classes.answersContainer}>
        {question.answers.map((answer) => {
          return (
            <Answer
              key={question.question.concat(answer.id)}
              question={question.question}
              value={answer.value}
              description={answer.description}
              id={answer.id}
              linksTo={answer.linksTo}
              submitAnswer={submitAnswer}
              svgName={answer.svgName}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Answers;
